import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const DEFAULT_USERS = [
  {
    id: 1,
    employeeCode: 'NV001',
    name: 'Nguyễn Văn A',
    email: 'nguyenvana@bank.vn',
    phone: '0901234567',
    roleIds: [1],
    department: 'IT',
    branches: ['all'],
    positions: [1],
    status: 'Hoạt động',
    lastLogin: '25/05/2026 10:00'
  },
  {
    id: 2,
    employeeCode: 'NV002',
    name: 'Trần Thị B',
    email: 'tranthib@bank.vn',
    phone: '0901234568',
    roleIds: [2, 3],
    department: 'Tín dụng',
    branches: ['CN TP HCM', 'CN Đà Nẵng'],
    positions: [2, 3],
    status: 'Hoạt động',
    lastLogin: '25/05/2026 09:30'
  },
  {
    id: 3,
    employeeCode: 'NV003',
    name: 'Lê Văn C',
    email: 'levanc@bank.vn',
    phone: '0901234569',
    roleIds: [3],
    department: 'Rủi ro',
    branches: ['CN Hà Nội'],
    positions: [4],
    status: 'Hoạt động',
    lastLogin: '25/05/2026 08:45'
  }
];

function Users({ showToast }) {
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'

  // Available branches and positions
  const availableBranches = [
    { id: 1, code: 'CN Hà Nội', name: 'Chi nhánh Hà Nội' },
    { id: 2, code: 'CN TP HCM', name: 'Chi nhánh Hồ Chí Minh' },
    { id: 3, code: 'CN Đà Nẵng', name: 'Chi nhánh Đà Nẵng' },
    { id: 4, code: 'CN Hải Phòng', name: 'Chi nhánh Hải Phòng' },
    { id: 5, code: 'CN Cần Thơ', name: 'Chi nhánh Cần Thơ' },
    { id: 6, code: 'CN Nha Trang – Khánh Hòa', name: 'Chi nhánh Nha Trang – Khánh Hòa' },
  ];

  const availablePositions = [
    { id: 1, code: 'CEO', name: 'Tổng Giám đốc' },
    { id: 2, code: 'BR-MGR', name: 'Giám đốc Chi nhánh' },
    { id: 3, code: 'DEPT-MGR', name: 'Trưởng phòng' },
    { id: 4, code: 'RM', name: 'Chuyên viên Quan hệ Khách hàng' },
    { id: 5, code: 'TELLER', name: 'Giao dịch viên' },
    { id: 6, code: 'LOAN-OFF', name: 'Chuyên viên Tín dụng' },
  ];

  const availableRoles = [
    { id: 1, code: 'ADMIN', name: 'Quản trị viên' },
    { id: 2, code: 'MANAGER', name: 'Quản lý' },
    { id: 3, code: 'ANALYST', name: 'Chuyên viên phân tích' },
    { id: 4, code: 'VIEWER', name: 'Người xem' }
  ];

  const [users, setUsers] = useState(() => {
    try {
      const savedUsers = localStorage.getItem('ews_users');
      return savedUsers ? JSON.parse(savedUsers) : DEFAULT_USERS;
    } catch (error) {
      console.error('Failed to parse users from localStorage:', error);
      return DEFAULT_USERS;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('ews_users', JSON.stringify(users));
    } catch (error) {
      console.error('Failed to persist users to localStorage:', error);
    }
  }, [users]);

  const [formData, setFormData] = useState({
    employeeCode: '',
    name: '',
    email: '',
    phone: '',
    roleIds: [],
    department: '',
    branches: [],
    positions: [],
    password: '',
    confirmPassword: ''
  });

  const getRoleName = (roleId) => {
    return availableRoles.find(r => r.id === roleId)?.name || 'N/A';
  };

  const getRoleNames = (roleIds) => {
    if (!roleIds || roleIds.length === 0) return 'Chưa có';
    return roleIds.map(id => getRoleName(id)).join(', ');
  };

  const filterUsers = () => {
    return users.filter(user => {
      const matchesSearch = user.name.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email.toLowerCase().includes(searchText.toLowerCase()) ||
        user.employeeCode.toLowerCase().includes(searchText.toLowerCase());
      const matchesRole = !roleFilter || (user.roleIds && user.roleIds.includes(parseInt(roleFilter)));
      const matchesStatus = !statusFilter || user.status === statusFilter;
      
      return matchesSearch && matchesRole && matchesStatus;
    });
  };

  const getRoleBadgeClass = (roleId) => {
    if (roleId === 1) return 'danger';  // Admin
    if (roleId === 2) return 'primary'; // Manager
    if (roleId === 3) return 'success'; // Analyst
    return 'secondary';  // Viewer
  };

  const getStatusBadgeClass = (status) => {
    return status === 'Hoạt động' ? 'success' : 'secondary';
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Convert data to react-select format
  const branchOptions = [
    { value: 'all', label: 'Tất cả chi nhánh' },
    ...availableBranches.map(b => ({ 
      value: b.code, // Use branch code (name) as value for consistency
      label: `${b.code} - ${b.name}` 
    }))
  ];

  const positionOptions = availablePositions.map(p => ({ 
    value: p.id, 
    label: `${p.code} - ${p.name}` 
  }));

  const roleOptions = availableRoles.map(r => ({ 
    value: r.id, 
    label: r.name 
  }));

  const handleBranchesChange = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setFormData(prev => ({ ...prev, branches: [] }));
      return;
    }
    
    const values = selectedOptions.map(opt => opt.value);
    
    // If 'all' is selected, only keep 'all'
    if (values.includes('all')) {
      setFormData(prev => ({ ...prev, branches: ['all'] }));
    } else {
      setFormData(prev => ({ ...prev, branches: values }));
    }
  };

  const handlePositionsChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      positions: selectedOptions ? selectedOptions.map(opt => opt.value) : []
    }));
  };

  const handleRoleChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      roleIds: selectedOptions ? selectedOptions.map(opt => opt.value) : []
    }));
  };

  const openCreateModal = () => {
    setEditingUser(null);
    setFormData({
      employeeCode: '',
      name: '',
      email: '',
      phone: '',
      roleIds: [],
      department: '',
      branches: [],
      positions: [],
      password: '',
      confirmPassword: ''
    });
    setShowModal(true);
  };

  const openEditModal = (user) => {
    setEditingUser(user);
    setFormData({
      employeeCode: user.employeeCode,
      name: user.name,
      email: user.email,
      phone: user.phone,
      roleIds: user.roleIds || [],
      department: user.department,
      branches: user.branches || [],
      positions: user.positions || [],
      password: '',
      confirmPassword: ''
    });
    setShowModal(true);
  };

  const handleSaveUser = (e) => {
    e.preventDefault();

    // Validation
    if (!formData.employeeCode || !formData.name || !formData.email || !formData.phone || !formData.department) {
      showToast('Vui lòng điền đầy đủ thông tin bắt buộc', 'warning');
      return;
    }

    if (!editingUser && (!formData.password || formData.password !== formData.confirmPassword)) {
      showToast('Mật khẩu không khớp', 'warning');
      return;
    }

    if (editingUser) {
      // Update existing user
      setUsers(users.map(user => 
        user.id === editingUser.id 
          ? { 
              ...user, 
              employeeCode: formData.employeeCode,
              name: formData.name,
              email: formData.email,
              phone: formData.phone,
              roleIds: formData.roleIds,
              department: formData.department,
              branches: formData.branches,
              positions: formData.positions
            } 
          : user
      ));
      showToast('Đã cập nhật người dùng thành công', 'success');
    } else {
      // Create new user
      const newUser = {
        id: users.length > 0 ? Math.max(...users.map(u => u.id)) + 1 : 1,
        employeeCode: formData.employeeCode,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        roleIds: formData.roleIds,
        department: formData.department,
        branches: formData.branches,
        positions: formData.positions,
        status: 'Hoạt động',
        lastLogin: 'Chưa đăng nhập'
      };
      setUsers([...users, newUser]);
      showToast('Đã tạo người dùng mới thành công', 'success');
    }

    setShowModal(false);
  };

  const deleteUser = (userId) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa người dùng này?')) {
      setUsers(users.filter(user => user.id !== userId));
      showToast('Đã xóa người dùng thành công', 'success');
    }
  };

  const toggleUserStatus = (userId) => {
    setUsers(users.map(user => 
      user.id === userId 
        ? { ...user, status: user.status === 'Hoạt động' ? 'Không hoạt động' : 'Hoạt động' }
        : user
    ));
    showToast('Đã cập nhật trạng thái người dùng', 'success');
  };

  const resetPassword = (userId) => {
    if (window.confirm('Bạn có chắc muốn reset mật khẩu cho người dùng này?')) {
      showToast('Đã gửi email reset mật khẩu cho người dùng', 'success');
    }
  };

  const getBranchNames = (branches) => {
    if (!branches || branches.length === 0) return 'Chưa có';
    if (branches.includes('all')) return 'Tất cả';
    // branches now contains branch codes directly
    return branches.join(', ');
  };

  const getPositionNames = (positionIds) => {
    if (!positionIds || positionIds.length === 0) return 'Chưa có';
    return positionIds
      .map(id => availablePositions.find(p => p.id === id)?.code)
      .filter(Boolean)
      .join(', ');
  };

  const filteredUsers = filterUsers();

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <i className="bi bi-people me-2"></i>
              Quản lý Người dùng
            </h2>
            <p className="text-muted mb-0">Quản lý tài khoản và phân quyền người dùng hệ thống</p>
          </div>
          <button className="btn btn-primary" onClick={openCreateModal}>
            <i className="bi bi-plus-circle me-1"></i>
            Tạo người dùng mới
          </button>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <input 
                type="text" 
                className="form-control" 
                placeholder="Tìm kiếm theo tên, email, mã NV..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <select 
                className="form-select"
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              >
                <option value="">Tất cả vai trò</option>
                {availableRoles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select 
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Tất cả trạng thái</option>
                <option value="Hoạt động">Hoạt động</option>
                <option value="Không hoạt động">Không hoạt động</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Users Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Mã NV</th>
                  <th>Họ tên</th>
                  <th>Email</th>
                  <th>Điện thoại</th>
                  <th>Chi nhánh</th>
                  <th>Vị trí</th>
                  <th>Vai trò</th>
                  <th>Trạng thái</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user.id}>
                      <td><strong>{user.employeeCode}</strong></td>
                      <td>{user.name}</td>
                      <td><small>{user.email}</small></td>
                      <td><small>{user.phone}</small></td>
                      <td><small className="text-info">{getBranchNames(user.branches)}</small></td>
                      <td><small className="text-warning">{getPositionNames(user.positions)}</small></td>
                      <td>
                        {user.roleIds && user.roleIds.length > 0 ? (
                          user.roleIds.map(roleId => (
                            <span key={roleId} className={`badge bg-${getRoleBadgeClass(roleId)} me-1 mb-1`}>
                              {getRoleName(roleId)}
                            </span>
                          ))
                        ) : (
                          <span className="badge bg-secondary">Chưa có</span>
                        )}
                      </td>
                      <td>
                        <span 
                          className={`badge bg-${getStatusBadgeClass(user.status)}`}
                          onClick={() => toggleUserStatus(user.id)}
                          style={{cursor: 'pointer'}}
                          title="Click để thay đổi trạng thái"
                        >
                          {user.status}
                        </span>
                      </td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => openEditModal(user)}
                          title="Chỉnh sửa"
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-warning me-1"
                          onClick={() => resetPassword(user.id)}
                          title="Reset mật khẩu"
                        >
                          <i className="bi bi-key"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => deleteUser(user.id)}
                          title="Xóa"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      <i className="bi bi-inbox fs-1"></i>
                      <p className="mt-2">Không tìm thấy người dùng nào</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingUser ? 'Chỉnh sửa người dùng' : 'Tạo người dùng mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSaveUser}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Mã nhân viên <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="employeeCode"
                        className="form-control"
                        value={formData.employeeCode}
                        onChange={handleInputChange}
                        placeholder="VD: NV001"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Họ và tên <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Nhập họ tên đầy đủ"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="user@bank.vn"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Số điện thoại <span className="text-danger">*</span></label>
                      <input
                        type="tel"
                        name="phone"
                        className="form-control"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="0901234567"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Vai trò hệ thống</label>
                      <Select
                        isMulti
                        options={roleOptions}
                        value={roleOptions.filter(opt => formData.roleIds.includes(opt.value))}
                        onChange={handleRoleChange}
                        placeholder="Tìm kiếm và chọn vai trò..."
                        isClearable={true}
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        noOptionsMessage={() => 'Không tìm thấy'}
                      />
                      <small className="text-muted">Đã chọn: {formData.roleIds.length} vai trò</small>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Phòng ban <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="department"
                        className="form-control"
                        value={formData.department}
                        onChange={handleInputChange}
                        placeholder="VD: Tín dụng"
                        required
                      />
                    </div>

                    {/* Multi-select for Branches */}
                    <div className="col-md-6">
                      <label className="form-label">Đơn vị công tác (Chi nhánh)</label>
                      <Select
                        isMulti
                        options={branchOptions}
                        value={branchOptions.filter(opt => formData.branches.includes(opt.value))}
                        onChange={handleBranchesChange}
                        placeholder="Tìm kiếm và chọn chi nhánh..."
                        isClearable={true}
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        noOptionsMessage={() => 'Không tìm thấy'}
                      />
                      <small className="text-muted">
                        {formData.branches.includes('all') 
                          ? 'Đang chọn: Tất cả chi nhánh' 
                          : `Đã chọn: ${formData.branches.length} chi nhánh`}
                      </small>
                    </div>

                    {/* Multi-select for Positions */}
                    <div className="col-md-6">
                      <label className="form-label">Vị trí đảm nhận</label>
                      <Select
                        isMulti
                        options={positionOptions}
                        value={positionOptions.filter(opt => formData.positions.includes(opt.value))}
                        onChange={handlePositionsChange}
                        placeholder="Tìm kiếm và chọn vị trí..."
                        isClearable={true}
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        noOptionsMessage={() => 'Không tìm thấy'}
                      />
                      <small className="text-muted">Đã chọn: {formData.positions.length} vị trí</small>
                    </div>

                    {!editingUser && (
                      <>
                        <div className="col-md-6">
                          <label className="form-label">Mật khẩu <span className="text-danger">*</span></label>
                          <input
                            type="password"
                            name="password"
                            className="form-control"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Nhập mật khẩu"
                            required={!editingUser}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Xác nhận mật khẩu <span className="text-danger">*</span></label>
                          <input
                            type="password"
                            name="confirmPassword"
                            className="form-control"
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            placeholder="Nhập lại mật khẩu"
                            required={!editingUser}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-2"></i>
                    {editingUser ? 'Cập nhật' : 'Tạo mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Users;
